import { AnyAction } from 'redux';

import NewsItem from '../api/newsItemEntity';
import WelcomePageHeroBanner from '../api/welcomePageHeroBannerEntity';
import WelcomePageHighlightBlock from '../api/welcomePageHighlightBlockEntity';
import { actionTypes } from '../common/constants/actionTypes';

export interface IWelcomePageContentState {
  heroBanner: WelcomePageHeroBanner;
  mainHighlightItems: WelcomePageHighlightBlock[];
  newsItems: NewsItem[];
  subMainHighlightItems: WelcomePageHighlightBlock[];
}

const initialState: IWelcomePageContentState = {
  heroBanner: new WelcomePageHeroBanner(),
  mainHighlightItems: [],
  newsItems: [],
  subMainHighlightItems: [],
};

export const welcomePageContentReducer = (
  state: IWelcomePageContentState = initialState,
  action: AnyAction
): IWelcomePageContentState => {
  switch (action.type) {
    case actionTypes.FETCH_WELCOME_PAGE_HERO_BANNER_COMPLETED:
      return {
        ...state,
        heroBanner: (action.payload as WelcomePageHeroBanner) || new WelcomePageHeroBanner(),
      };

    case actionTypes.FETCH_WELCOME_PAGE_HIGHLIGHT_MAIN_ITEMS_COMPLETED:
      return {
        ...state,
        mainHighlightItems: (action.payload as WelcomePageHighlightBlock[]) || [],
      };

    case actionTypes.FETCH_WELCOME_PAGE_HIGHLIGHT_SUB_MAIN_ITEMS_COMPLETED:
      return {
        ...state,
        subMainHighlightItems: (action.payload as WelcomePageHighlightBlock[]) || [],
      };

    case actionTypes.FETCH_WELCOME_PAGE_NEWS_ITEMS_COMPLETED:
      return {
        ...state,
        newsItems: (action.payload as NewsItem[]) || [],
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/welcomePageContent.ts